import { Post, site } from './data';

export function pageTitle(title?: string) {
  return title ? `${title} | ${site.name}` : site.name;
}

export function articleSchema(post: Post) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.dek,
    datePublished: post.updated,
    dateModified: post.updated,
    author: {
      '@type': 'Organization',
      name: site.name
    },
    publisher: {
      '@type': 'Organization',
      name: site.name,
      url: site.url
    },
    mainEntityOfPage: `${site.url}/blog/${post.slug}`,
    keywords: post.keywords.join(', '),
    about: post.countryFocus.map((country) => ({ '@type': 'Country', name: country })),
    citation: post.sources.map((source) => source.url)
  };
}

export function faqSchema(post: Post) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: post.faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
}

export function websiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: site.name,
    url: site.url,
    description: site.description
  };
}
